var _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgOtherPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3727_25121",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3727_25121)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81C66.5685 81 80 67.5685 80 51C80 34.4315 66.5685 21 50 21C33.4315 21 20 34.4315 20 51C20 67.5685 33.4315 81 50 81Z",
    fill: "#68A4D4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3727_25121",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 25,
    width: 52,
    height: 52
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9999 76.7142C64.2015 76.7142 75.7142 65.2015 75.7142 50.9999C75.7142 36.7983 64.2015 25.2856 49.9999 25.2856C35.7983 25.2856 24.2856 36.7983 24.2856 50.9999C24.2856 65.2015 35.7983 76.7142 49.9999 76.7142Z",
    fill: "#EDF5F1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3727_25121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5357 49.9284C54.9737 49.9284 58.5714 46.3307 58.5714 41.8926C58.5714 37.4546 54.9737 33.8569 50.5357 33.8569C46.0977 33.8569 42.5 37.4546 42.5 41.8926C42.5 46.3307 46.0977 49.9284 50.5357 49.9284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9999 87.4286C60.0594 87.4286 68.2142 79.2738 68.2142 69.2143C68.2142 59.1548 60.0594 51 49.9999 51C39.9405 51 31.7856 59.1548 31.7856 69.2143C31.7856 79.2738 39.9405 87.4286 49.9999 87.4286Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgOtherPerson);
export default __webpack_public_path__ + "static/media/imgOtherPerson.c81abea0ccea4bd9a8803a5da28793ea.svg";
export { ForwardRef as ReactComponent };